var exports = {
  "kL": "AppSkeleton.module__container___NnVBZE",
  "ER": "AppSkeleton.module__containerExiting___NnVBZE",
  "A1": "AppSkeleton.module__containerGuilds___NnVBZE",
  "BG": "AppSkeleton.module__containerRailless___NnVBZE",
  "w_": "AppSkeleton.module__containerReserveUserArea___NnVBZE",
  "u5": "AppSkeleton.module__containerReserveMobileBottomNav___NnVBZE",
  "aF": "AppSkeleton.module__outlineFrame___NnVBZE",
  "Qs": "AppSkeleton.module__content___NnVBZE",
  "iW": "AppSkeleton.module__main___NnVBZE",
  "NK": "AppSkeleton.module__mainSidebarless___NnVBZE",
  "qy": "AppSkeleton.module__contentColumn___NnVBZE",
};

module.exports = exports;
